import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CompanySkeleton = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-Light-purple to-turquoise p-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Columna izquierda */}
          <div className="lg:col-span-4">
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700/50">
              <div className="flex flex-col items-center mb-6">
                {/* Avatar */}
                <Skeleton circle width={128} height={128} className="mb-4" />

                {/* Nombre de empresa */}
                <div className="flex items-center gap-2 mb-2 w-full justify-center">
                  <Skeleton width={180} height={28} />
                </div>

                {/* Estado del perfil */}
                <Skeleton width={120} height={20} className="mb-4" />
              </div>

              {/* Descripción */}
              <div className="mb-8">
                <Skeleton count={3} className="mb-2" />
                <Skeleton width={160} />
              </div>

              {/* Botones */}
              <div className="space-y-3">
                <Skeleton height={48} />
                <Skeleton height={48} />
                <Skeleton height={48} />
              </div>

              {/* Redes sociales */}
              {/* <div className="mt-8 flex justify-center gap-4">
                {[...Array(4)].map((_, i) => (
                  <Skeleton key={i} circle width={24} height={24} />
                ))}
              </div> */}
            </div>
          </div>

          {/* Columna derecha */}
          <div className="lg:col-span-8">
            {/* Botones de acción */}
            <div className="flex justify-end gap-3 mb-6">
              <Skeleton width={120} height={40} />
              <Skeleton width={100} height={40} />
            </div>

            {/* Tarjetas de información */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50">
                  <div className="flex items-center gap-4">
                    <Skeleton circle width={48} height={48} />
                    <div className="flex flex-wrap">
                      <div className='w-full'>
                        <Skeleton width={120} height={20} className="mb-1" />
                      </div>
                      <Skeleton width={100} height={16} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanySkeleton;